import { z } from "zod";

import { FEED_TYPES } from "./feed-types";
import { dateSchema } from "./utils";

const feedSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string(),
  pinned: z.boolean().catch(false),
  can_unpin: z.boolean().catch(true),
  can_delete: z.boolean().catch(true),
  can_sort: z.boolean().catch(true),
  feed_type: z.enum(FEED_TYPES),
  visibility: z.enum(["public", "private"]),
  seen: z.boolean().catch(true),
  created_by_account_id: z.string(),
  created_at: dateSchema,
});

type Feed = z.infer<typeof feedSchema>;

export { feedSchema, type Feed };
